import { z } from 'zod';

export const manageGroupNameResponseSchema = z.object({
  id: z.string().uuid()
});
